// extracted by mini-css-extract-plugin
module.exports = {"staff_head":"Staff_staff_head__3HbEz","staff_body":"Staff_staff_body__m1369"};